<template>
  <div class="pl-kaptcha">
    <el-button>123</el-button>
  </div>
</template>
<script>
import { getKaptchaData } from "./api";
import "element-ui/lib/theme-chalk/index.css";
import { Button as ElButton } from "element-ui";
export default {
  name: "PlKaptcha",
  components: {
    ElButton
  },
  methods: {
    async getKaptchaData() {
      try {
        const { success, message, data } = await getKaptchaData();
        if (!success) {
          return console.log("系统平台错误，获取验证码信息失败：" + message);
        }
        this.kaptcha = data;
      } catch (error) {
        console.log("系统平台错误，获取验证码信息失败", error);
      }
    }
  },
  created() {
    this.getKaptchaData();
  },
  data() {
    return {
      kaptcha: {}
    };
  }
};
</script>
<style lang="scss">
.pl-kaptcha {
  width: 100%;
  height: 100%;
  div {
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Kaptcha/index.vue